import {
  QUANTUM,
  EPIC,
  FIXED,
  CHOICE,
  DELUXE,
  ECONOMY,
  STANDARD,
  CORE
} from 'core/constants/products'

function freeLookPeriod(state: string, productId: number): number {
  switch (productId) {
    case FIXED:
      return 30
    case QUANTUM:
      return ['LA', 'IN'].indexOf(state) >= 0 ? 30 : 10

    case CHOICE:
    case DELUXE:
    case ECONOMY:
    case STANDARD:
    case CORE:
    case EPIC:
      return ['LA'].indexOf(state) >= 0 ? 30 : 10

    default:
      return 10
  }
}

export default freeLookPeriod
